import { sortBetSize } from '../../../helpers/helpers'

export const getActionsHash = ({ player, allActions, currentPlayer, players }) => {
	const raiseIndex = []

	for (let i = 0; i < allActions.length; i++) {
		if (
			(allActions[i].action.includes('Bet') || allActions[i].action.includes('Raise')) &&
			!allActions[i].is_allin
		) {
			raiseIndex.push(allActions[i].action)
		}
	}

	raiseIndex.sort((a, b) => sortBetSize(a, b))

	return allActions.reduce((hash, { action, is_allin, played, ev, gto_range }) => {
		return (
			(hash[action] = {
				is_allin,
				played: played[players[player].handIndex],
				rI: raiseIndex.indexOf(action),
				ev: ev[players[player].handIndex],
				gto_range,
				player: currentPlayer,
			}),
			hash
		)
	}, {})
}
